
const Footer = () => {
  return <footer className="bg-[#F8FAFF] text-gray-800 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="border-t border-gray-200 pt-8 text-gray-600 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p>© 2025 Vertigo AI. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="/privacy-policy" className="hover:text-gray-900 transition-colors duration-300">Privacy Policy</a>
              <a href="/terms-of-service" className="hover:text-gray-900 transition-colors duration-300">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
